const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL +'/api/v1';

export const API_ENDPOINTS = {
    BASE: `${API_BASE_URL}`,
    ABBR: {
        DASHBOARD: {url: `/dashboard/words-and-terms`, method: 'GET'},
        PRJ: {
            PRNT: {
                LIST: {url: `/projects`, method: 'GET'},
                DTL: (prjId: string | number) => {return {url: `/projects/${prjId}`, method: 'GET'}},
                CREATE: {url: `/projects`, method: 'POST'},
                UPDT: (prjId: string | number) => {return {url: `/projects/${prjId}`, method: 'PUT'}},
                DELETE: (prjId: string | number) => {return {url: `/projects/${prjId}`, method: 'DELETE'}},
                OWNR_TRNSF: (prjId: string | number) => {return {url: `/projects/${prjId}/ownership/transfer`, method: 'POST'}},
                CONF: {
                    DTL: (prjId: string | number) => {return {url: `/projects/${prjId}/config`,method: 'GET'}},
                    UPDT: (prjId: string | number) =>  {return {url: `/projects/${prjId}/config`,method: 'PUT'}}
                    // , PTCH_MOIS_VER: (prjId: string | number) =>  {return {url: `/projects/${prjId}/settings/${prjId}/version`,method: 'PATCH'}},
                }
            },
            SUB: {
                LIST: (prntPrjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects`, method: 'GET' };
                },
                DTL: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}`, method: 'GET' };
                },
                CREATE: (prntPrjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects`, method: 'POST' };
                },
                UPDT: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}`, method: 'PUT' };
                },
                DELETE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}`, method: 'DELETE' };
                },
                OWNR_TRNSF: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/ownership/transfer`, method: 'POST' };
                },
            },
            WORD: {
                LIST: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words`, method: 'GET' };
                },
                DTL: (prntPrjId: string | number, prjId: string | number, stdWordId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words/${stdWordId}`, method: 'GET' };
                },
                CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words`, method: 'POST' };
                },
                UPDT: (prntPrjId: string | number, prjId: string | number, stdWordId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words/${stdWordId}`, method: 'PUT' };
                },
                DELETE: (prntPrjId: string | number, prjId: string | number, stdWordId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words/${stdWordId}`, method: 'DELETE' };
                },
                BULK_UPLOAD: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words/excel/upload`, method: 'POST' };
                },
                BULK_CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/words/bulk`, method: 'POST' };
                },
                CONF: {
                    DTL: (prntPrjId: string | number, prjId: string | number) => {
                        return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/word-config`, method: 'GET' };
                    },
                    UPDT: (prntPrjId: string | number, prjId: string | number) => {
                        return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/word-config`, method: 'PUT' };
                    },
                },
            },
            TRM: {
                LIST: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms`, method: 'GET' };
                },
                DTL: (prntPrjId: string | number, prjId: string | number, stdTrmId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms/${stdTrmId}`, method: 'GET' };
                },
                CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms`, method: 'POST' };
                },
                UPDT: (prntPrjId: string | number, prjId: string | number, stdTrmId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms/${stdTrmId}`, method: 'PUT' };
                },
                DELETE: (prntPrjId: string | number, prjId: string | number, stdTrmId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms/${stdTrmId}`, method: 'DELETE' };
                },
                BULK_UPLOAD: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms/excel/upload`, method: 'POST' };
                },
                BULK_CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/terms/bulk`, method: 'POST' };
                },
                CONF: {
                    DTL: (prntPrjId: string | number, prjId: string | number) => {
                        return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/term-config`, method: 'GET' };
                    },
                    UPDT: (prntPrjId: string | number, prjId: string | number) => {
                        return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/term-config`, method: 'PUT' };
                    },
                },
            },
            DMN: {
                LIST: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains`, method: 'GET' };
                },
                DTL: (prntPrjId: string | number, prjId: string | number, stdDmnId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains/${stdDmnId}`, method: 'GET' };
                },
                CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains`, method: 'POST' };
                },
                UPDT: (prntPrjId: string | number, prjId: string | number, stdDmnId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains/${stdDmnId}`, method: 'PUT' };
                },
                DELETE: (prntPrjId: string | number, prjId: string | number, stdDmnId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains/${stdDmnId}`, method: 'DELETE' };
                },
                BULK_UPLOAD: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains/excel/upload`, method: 'POST' };
                },
                BULK_CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domains/bulk`, method: 'POST' };
                },
                CONF: {
                    DTL: (prntPrjId: string | number, prjId: string | number) => {return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-config`, method: 'GET' };},
                    UPDT: (prntPrjId: string | number, prjId: string | number) => {return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-config`, method: 'PUT' };},
                },
            },
            DMN_GRP: {
                LIST: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups`, method: 'GET' };
                },
                DTL: (prntPrjId: string | number, prjId: string | number, stdDmnGrpId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups/${stdDmnGrpId}`, method: 'GET' };
                },
                CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups`, method: 'POST' };
                },
                UPDT: (prntPrjId: string | number, prjId: string | number, stdDmnGrpId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups/${stdDmnGrpId}`, method: 'PUT' };
                },
                DELETE: (prntPrjId: string | number, prjId: string | number, stdDmnGrpId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups/${stdDmnGrpId}`, method: 'DELETE' };
                },
                BULK_UPLOAD: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups/excel/upload`, method: 'POST' };
                },
                BULK_CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-groups/bulk`, method: 'POST' };
                },
                CONF: {
                    DTL: (prntPrjId: string | number, prjId: string | number) => {return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-group-config`, method: 'GET' };},
                    UPDT: (prntPrjId: string | number, prjId: string | number) => {return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-group-config`, method: 'PUT' };},
                },
            },
            DMN_CTGRY: {
                LIST: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories`, method: 'GET' };
                },
                DTL: (prntPrjId: string | number, prjId: string | number, stdDmnGrpId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories/${stdDmnGrpId}`, method: 'GET' };
                },
                CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories`, method: 'POST' };
                },
                UPDT: (prntPrjId: string | number, prjId: string | number, stdDmnGrpId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories/${stdDmnGrpId}`, method: 'PUT' };
                },
                DELETE: (prntPrjId: string | number, prjId: string | number, stdDmnGrpId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories/${stdDmnGrpId}`, method: 'DELETE' };
                },
                BULK_UPLOAD: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories/excel/upload`, method: 'POST' };
                },
                BULK_CREATE: (prntPrjId: string | number, prjId: string | number) => {
                    return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-categories/bulk`, method: 'POST' };
                },
                CONF: {
                    DTL: (prntPrjId: string | number, prjId: string | number) => {return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-category-config`, method: 'GET' };},
                    UPDT: (prntPrjId: string | number, prjId: string | number) => {return { url: `/projects/${prntPrjId}/sub-projects/${prjId}/domain-category-config`, method: 'PUT' };},
                },
            },
            MBR: {
                LIST: (prjId: string | number) => {return { url: `/projects/${prjId}/members`, method: 'GET' };},
                DTL: (prjId: string | number, prjMbrId: string | number) => {return { url: `/projects/${prjId}/members/${prjMbrId}`, method: 'GET' };},
                DELETE: (prjId: string | number, prjMbrId: string | number) => {return { url: `/projects/${prjId}/members/${prjMbrId}`, method: 'DELETE' };},
                UPDT_ROLE: (prjId: string | number, prjMbrId: string | number) => {return { url: `/projects/${prjId}/members/${prjMbrId}/role`, method: 'PUT' };},
            },
            INVITE: {
                LIST: (prjId: string | number) => {return {url: `/projects/${prjId}/invites`, method: 'GET'}},
                CREATE: (prjId: string | number) => {return {url: `/projects/${prjId}/invites`, method: 'POST'}},
                UPDT: (prjId: string | number, invttId: string | number) => {return {url: `/projects/${prjId}/invites/${invttId}`,method: 'PUT'}},
                DELETE: (prjId: string | number, prjInvttId: string | number) => {return {url: `/projects/${prjId}/invites/${prjInvttId}`,method: 'DELETE'}},
                VALID_EMAIL: (prjId: string | number) => {return {url: `/projects/${prjId}/invites/validate-email`,method: 'PUT'}},
                VALID: (prjId: string | number, invttId: string | number) => {return {url: `/projects/${prjId}/invites/${invttId}/validate`,method: 'POST'}},
            },
            APRV_RQST: {
                LIST: (prntPrjId: string | number, prjId: string | number) => {return {url: `/projects/${prntPrjId}/sub-projects/${prjId}/approval-requests`,method: 'GET'}},
                DTL: (prntPrjId: string | number, prjId: string | number, aprvRqstId: string | number) => {return {url: `/projects/${prntPrjId}/sub-projects/${prjId}/approval-requests/${aprvRqstId}`,method: 'GET'}},
                APRV: (prntPrjId: string | number, prjId: string | number, aprvRqstId: string | number) => {return {url: `/projects/${prntPrjId}/sub-projects/${prjId}/approval-requests/${aprvRqstId}/approve`,method: 'POST'}},
                RJCT: (prntPrjId: string | number, prjId: string | number, aprvRqstId: string | number) => {return {url: `/projects/${prntPrjId}/sub-projects/${prjId}/approval-requests/${aprvRqstId}/reject`,method: 'PATCH'}},
            },
            DASHBOARD: {url: '/dashboard/words-and-terms', method: 'GET'}
        },
        USR: {
            DTL: (usrId: string) => {return {url: `/users/${usrId}`, method: 'GET'}},
            CREATE: {url: `/users`, method: 'POST'},
            UPDT: (usrId: string) => {return {url: `/users/${usrId}`, method: 'PUT'}},
            DELETE: (usrId: string) => {return {url: `/users/${usrId}`, method: 'DELETE'}},
            UPDT_PSWD: (usrId: string) => {return {url: `/users/${usrId}/password`, method: 'POST'}},
        },
        AGRE: {
            LIST: {url: `/agreements`, method: 'GET'},
        },
    },
    AUTH: {
        LOGIN: {url: `/auth/login`, method: 'POST'},
        LOGOUT: {url: `/auth/logout`, method: 'POST'},
        RENEW: {url: `/auth/renew`, method: 'POST'},
        PSWD: {
            RESET_REQ: {url: `/auth/password-reset-request`, method: 'POST'},
            VALID: {url: `/auth/password-reset`, method: 'GET'},
            RESET: {url: `/auth/password-reset`, method: 'POST'},
        },
        EMAIL_VERIFICATION: {
            SEND_REQ : {url: `/auth/email-verification-request`, method: 'POST'},
            VALID : {url: `/auth/email-verification`, method: 'POST'}
        }
    },
    ADMN: {
        ROLE: {
            LIST: {url: `/admin/roles`, method: 'GET'},
            DTL: (roleId: string | number) => {return {url: `/admin/roles/${roleId}`, method: 'GET'}},
            CREATE: {url: `/admin/roles`, method: 'POST'},
            UPDT: (roleId: string | number) => {return {url: `/admin/roles/${roleId}`, method: 'PUT'}},
            DELETE: (roleId: string | number) => {return {url: `/admin/roles/${roleId}`, method: 'DELETE'}},
        },
        CODE: {
            ENUM: {url: `/admin/common-codes/enum`, method: 'GET'},
            LIST: {url: `/admin/common-codes`, method: 'GET'},
            DTL: (comCd: string) => {return {url: `/admin/common-codes/${comCd}`, method: 'GET'}},
            CREATE: {url: `/admin/common-codes`, method: 'POST'},
            UPDT: (comCd: string) => {return {url: `/admin/common-codes/${comCd}`, method: 'PUT'}},
            DELETE: (comCd: string) => {return {url: `/admin/common-codes/${comCd}`, method: 'DELETE'}},
        },
        AUTHORITY: {
            ENUM: {url: `/admin/authorities/enum`, method: 'GET'},
            LIST: {url: `/admin/authorities`, method: 'GET'},
            DTL: (authrtId: string | number) => {return {url: `/admin/authorities/${authrtId}`, method: 'GET'}},
            CREATE: {url: `/admin/authorities`, method: 'POST'},
            UPDT: (authrtId: string | number) => {return {url: `/admin/authorities/${authrtId}`, method: 'PUT'}},
            DELETE: (authrtId: string | number) => {return {url: `/admin/authorities/${authrtId}`, method: 'DELETE'}},
        },
        USR: {
            LIST: {url: `/admin/users`, method: 'GET'},
            UPDT_ROLE: (usrId: string|number) => {return {url: `/admin/users/${usrId}/role`, method: 'PATCH'}},
        },
        VERSION: {url: `/admin/version`, method: 'GET'}
    }
}